import { Component, Input } from "@angular/core";

@Component({
  standalone: false,
  selector: "app-download-tabs",
  templateUrl: "./download-tabs.component.html",
  styleUrls: ["./download-tabs.component.scss"],
})
export class DownloadTabsComponent {
  @Input() archived: any;
  @Input() product = "";
  @Input() showISOs = true;
  @Input() showAPI = false;
  @Input() showUpgrades = false;
  @Input() showBundles = false;
  get hasInstallers(): boolean {
    return !!this.archived?.installs?.length;
  }

  get hasIsos(): boolean {
    return !!this.showISOs && !!this.archived?.isos?.length;
  }

  get hasApi(): boolean {
    return !!this.showAPI && !!this.archived?.api?.length;
  }

  get hasUpgrades(): boolean {
    return !!this.showUpgrades && !!this.archived?.upgrades?.length;
  }

  get hasBundles(): boolean {
    return !!this.showBundles && !!this.archived?.bundles?.length;
  }

  get hasDocumentation(): boolean {
    return !!this.archived?.documentation?.length;
  }
}
